const SubNav = {
  // el: {
  //   subNav: document.querySelector<HTMLElement>('.side-nav'),
  //   widthMatch: window.matchMedia("(max-width: 992px)")
  // },

  init() {
    //on load we the trigger the positioning of the active pill
    // SubNav.positionSubNav(SubNav.el.widthMatch)
    // SubNav.el.widthMatch.addEventListener('change', function (mm) {
    //   SubNav.positionSubNav(SubNav.checkWindowSize(SubNav.el.widthMatch))
    // });
  },

  //set the size
  // checkWindowSize(mm) {
  //   var size = "";

  //   if (mm.matches) {
  //     size = "small";
  //   } else {
  //     size = "large";
  //   }

  //   return size;
  // },

  // positionSubNav(size) {
  //   if(size == "large") {
  //     SubNav.el.subNav.classList.remove('hide')
  //   }

  //   if(size == "small") {
  //     SubNav.el.subNav.classList.add('hide')
  //   }
  // },
}

export default SubNav
